import { render, staticRenderFns } from "./BadgeRow.vue?vue&type=template&id=403512df&scoped=true&"
import script from "./BadgeRow.vue?vue&type=script&lang=js&"
export * from "./BadgeRow.vue?vue&type=script&lang=js&"
import style0 from "./BadgeRow.vue?vue&type=style&index=0&id=403512df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403512df",
  null
  
)

export default component.exports